import requests from "./request.js";

export const url = () => {
  return "//yuan.gzxb315.com";
};
// export const url = () => {
//   return "http://127.0.0.1:8080";
// };
// var storage = window.sessionStorage;
// var token1 = {
//     key: sessionStorage.getItem('token')
// }
// 获取key状态
// export const getKey = () => {return token1.key}

// 登录
export const login = (data) => requests.post("login/login.php", data);
// 登录状态查询
export const token = (data) => requests.post("config/LoginState.php", data);
// 修改用户密码
export const uppassword = (data) => requests.post("/users/", data);
// 获取高德地图配置数据
export const getGDkey = (data) => requests.post("setting/gd/gets/", data);
// 修改高德地图配置数据
export const upGDkey = (data) => requests.post("setting/gd/updata/", data);

// 获取地图统计数据
export const getStat = (data) => requests.post("stat/", data);
// 获取扫描次数统计数据
export const getOneDayStat = (data) => requests.post("stat/counts/", data);

// 添加企业信息
export const NewClients = (data) => requests.post("ClientData/set/", data);
// 删除企业信息
export const DelClients = (data) => requests.post("ClientData/delete/", data);
// 删除企业信息
export const updataClients = (data) =>
  requests.post("ClientData/updata/", data);
// 获取所有企业信息
export const GetClients = (data) => requests.post("ClientData/get/", data);
// 获取企业流水号
export const GetClientSerial = (data) =>
  requests.post("CodeList/get/getSerial.php", data);
// 查询 tally 表是否存在
export const GetTallyBool = (data) =>
  requests.post("ClientData/get/getTally.php", data);
// 新建 tally 表
export const newTally = (data) =>
  requests.post("ClientData/set/newTally.php", data);

// 添加生码信息
export const NewCodeList = (data) => requests.post("CodeList/set/", data);
// 删除生码信息
// export const DeleteCodeList = (data) => requests.post('CodeList/delete/', data)
// 获取所有生码信息
export const GetCodeList = (data) => requests.post("CodeList/get/", data);
// 通过批次号获取生码信息
// export const getBatchCodes = (data) => requests.post('CodeList/get/batch.php', data)
export const getBatchCodes = (data) =>
  requests.post("src/mnsms-2.php", data, { responseType: "blob" });
// 用于并发生成生码文件
export const getBatchCodefiles = (data) => requests.post("src/mnsm.php", data);

// 添加回复信息
export const setResultList = (data) => requests.post("ClientResult/set/", data);
// 更改回复信息
export const updataResultList = (data) =>
  requests.post("ClientResult/update/", data);
// 获取回复信息
export const GetResultList = (data) => requests.post("ClientResult/get/", data);
// 删除回复信息
export const DelResultList = (data) =>
  requests.post("ClientResult/delete/", data);

// 添加赋码信息
export const NewAssignList = (data) => requests.post("assignList/set/", data);
// 获取所有赋码信息
export const GetAssignList = (data) => requests.post("assignList/get/", data);
// 删除赋码信息
export const DelAssignList = (data) =>
  requests.post("assignList/delete/", data);
// 修改赋码信息
export const UpdataAssignList = (data) =>
  requests.post("assignList/updata/", data);

// 添加字段信息
export const NewFiledList = (data) => requests.post("filedList/set/", data);
// 获取所有字段信息
export const GetFiledList = (data) => requests.post("filedList/get/", data);
// 删除字段信息
export const DelFiledList = (data) => requests.post("filedList/delete/", data);
// 修改字段信息
export const updataFiledList = (data) =>
  requests.post("filedList/updata/", data);
// 上传图片
export const uploadImg = (data, config) =>
  requests.post("upload/", data, config);

// 获取查询记录
export const GetScanRecord = (data) => requests.post("selectCode/get/", data);

// 获取反馈列表
export const GetFeedBack = (data) => requests.post("feedback/get/", data);
// 获取反馈
export const deleteFeedBack = (data) => requests.post("feedback/delete/", data);

// 添加产品信息
export const NewProductList = (data) => requests.post("product/set/", data);
// 获取所有产品信息
export const GetProductList = (data) => requests.post("product/get/", data);
// 删除产品信息
export const DelProductList = (data) => requests.post("product/delete/", data);
// 修改产品信息
export const updataProductList = (data) =>
  requests.post("product/updata/", data);

// 添加产品字段
export const NewProductCustom = (data) =>
  requests.post("productCustom/set/", data);
// 获取产品字段
export const GetProductCustom = (data) =>
  requests.post("productCustom/get/", data);
// 获取所有产品字段
export const GetProductCustomAll = (data) =>
  requests.post("productCustom/get/all.php", data);
// 删除产品字段
export const DelProductCustom = (data) =>
  requests.post("productCustom/delete/", data);
// 修改产品字段
export const updataProductCustom = (data) =>
  requests.post("productCustom/updata/", data);

// 添加经销商信息
export const NewDealerList = (data) => requests.post("dealer/set/", data);
// 获取所有经销商信息
export const GetDealerList = (data) => requests.post("dealer/get/", data);
// 删除经销商信息
export const DelDealerList = (data) => requests.post("dealer/delete/", data);
// 修改经销商信息
export const UpdataDealerList = (data) => requests.post("dealer/updata/", data);

// 获取入库列表
export const GetStoraList = (data) =>
  requests.post("tally/storaList/get/", data);

// 获取出库列表
export const GetDeliveryList = (data) =>
  requests.post("tally/delivery/get/", data);

// 获取退货列表
export const GetSalesReturnList = (data) =>
  requests.post("tally/salesReturnList/get/", data);

// 获仓库列表
export const GetStorasList = (data) => requests.post("tally/stora/get/", data);
// 添加仓库
export const setStorasList = (data) => requests.post("tally/stora/set/", data);
// 修改仓库信息
export const updataStorasList = (data) =>
  requests.post("tally/stora/updata/", data);
// 删除仓库
export const deleteStorasList = (data) =>
  requests.post("tally/stora/delete/", data);

// 获取仓库人员列表
export const GetStoraUserList = (data) =>
  requests.post("tally/storaUser/get/", data);
// 修改仓库人员列表
export const updataStoraUserList = (data) =>
  requests.post("tally/storaUser/updata/", data);
// 删除仓库人员列表
export const deleteStoraUserList = (data) =>
  requests.post("tally/storaUser/delete/", data);
// 添加仓库人员列表
export const setStoraUserList = (data) =>
  requests.post("tally/storaUser/set/", data);

// 分发模块
// 获取分发记录
export const GetDispenseList = (data) => requests.post("dispense/get/", data);
// 添加分发记录
export const setDispense = (data) => requests.post("dispense/set/", data);
// 删除分发记录
export const DelDispense = (data) => requests.post("dispense/delete/", data);
// 删除分发记录
export const UpDispense = (data) => requests.post("dispense/updata/", data);

//查询统计
export const getDispenseStice = (data) =>
  requests.post("dispensestics/getsales/", data);
//查询统计---客户量
export const getCustomer = (data) =>
  requests.post("dispensestics/getcustomer/", data);
//查询统计---产品量
export const getProducts = (data) =>
  requests.post("dispensestics/getproducts/", data);
//查询统计---每日销量
export const getEveryday = (data) =>
  requests.post("dispensestics/everyday/", data);
//查询统计---客户销售排行
export const getMarket = (data) =>
  requests.post("dispensestics/getMarkets/", data);
//查询统计---产品销售排行
export const getproductMarket = (data) =>
  requests.post("dispensestics/getproductMarket/", data);
